import {
  Button,
  FormFieldSet,
  ProgressTabAdv,
} from "../../../../../../../components";
import { useState } from "react";

const RenewStep = ({ onBack, onContinue, currentPlan, tabs }) => {
  const [checkbox, setCheckbox] = useState([]);
  const [wfCheckBox, setWfCheckBox] = useState([]);
  const [toggleInput, setToggleInput] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState("Starter");

  const COMMON_FEATURES = [
    "Job Management",
    "Candidate Management",
    "Submission Management",
    "Account & Contact Management",
  ];

  const PLANS = ["Starter", "Professional", "Enterprise"];

  const getButtonLabel = (plan) => {
    const currentIndex = PLANS.indexOf(selectedPlan);
    const planIndex = PLANS.indexOf(plan);

    if (planIndex === currentIndex) return "Renew";
    if (planIndex < currentIndex) return "Select";
    return "Upgrade";
  };

  return (
    <div className="p-3 sm:p-4 md:p-5 flex flex-col flex-1 overflow-hidden">
      <div className="my-2">
        <Button
          title="Renew Plan"
          variant="text"
          color="black"
          size="lg"
          fromLeft
          icon="arrow_left_alt"
          className="self-start font-medium !px-2"
          onClick={onBack}
        />
      </div>

      <ProgressTabAdv tabs={tabs} />

      {/* ATS & Workforce */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 md:gap-5 mt-4 sm:mt-5 md:mt-5 mb-5 justify-center">
        {["ATS", "Workforce"].map((title) => (
          <div
            key={title}
            className="flex flex-col sm:flex-row items-start sm:items-center border border-gray-200 shadow-md rounded-md gap-3 sm:gap-0 sm:pr-12 p-3 sm:p-0"
          >
            <Button
              icon="page_info"
              variant="text"
              size="sm"
              type="icon"
              className="rounded-full bg-primary text-white sm:ml-3 p-5 flex-shrink-0"
            />

            <div className="card-content p-3 sm:p-5 w-full">
              <div className="flex justify-between items-start sm:items-center gap-2">
                <span className="title text-sm sm:text-base md:text-lg font-semibold">
                  {title}
                </span>

                <FormFieldSet
                  type="checkbox"
                  noTitle
                  values={title === "ATS" ? checkbox : wfCheckBox}
                  options={[{ label: "", value: "1" }]}
                  onChange={(values) =>
                    title === "ATS"
                      ? setCheckbox(values)
                      : setWfCheckBox(values)
                  }
                  multiple
                />
              </div>

              <p className="text-xs sm:text-sm md:text-base text-gray-600 mt-2">
                Manage recruitment with an AI-powered talent acquisition
                solution
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Billing Cycle */}
      <div className="flex flex-col justify-center items-center mt-4 sm:mt-6 md:mt-8">
        <div className="text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4">
          Billing Cycle
        </div>

        <div className="sm:w-auto sm:min-w-[300px] md:min-w-[350px] px-3 sm:px-0">
          <FormFieldSet
            value={toggleInput}
            type="toggleInput"
            onChange={setToggleInput}
            noTitle
            leftText="Monthly"
            rightText="Yearly"
            leftIcon={toggleInput && "check_circle"}
            rightIcon={!toggleInput && "check_circle"}
          />
        </div>
      </div>

      {/* Plans */}
      <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5 lg:gap-6 mt-6 sm:mt-8 md:mt-10 items-stretch">
        {PLANS.map((plan) => (
          <div key={plan} className="w-full h-full">
            <div className="flex flex-col h-full border border-gray-200 rounded-2xl shadow-2xl overflow-hidden">
              
              {/* Header */}
              <div className="p-3 sm:p-4 md:p-5 bg-white">
                <span className="inline-block px-3 py-1 rounded bg-primary-100 text-xs sm:text-sm md:text-base font-medium">
                  {plan}
                </span>
              </div>

              {/* Content */}
              <div
                className={`flex-1 ${
                  plan === "Enterprise" ? "p-3 sm:p-4 md:p-4.5" : "p-3 sm:p-4 md:p-4"
                } overflow-y-auto`}
              >
                {/* Input Fields or Description */}
                <div className="w-full">
                  {plan !== "Enterprise" ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
                      <div className="flex flex-col">
                        <FormFieldSet
                          title="ATS"
                          type="text"
                          placeholder="4"
                        />
                        <span className="text-neutrals-500 text-xs sm:text-sm mt-1">
                          2000/users
                        </span>
                      </div>
                      <div className="flex flex-col">
                        <FormFieldSet
                          title="Workforce"
                          type="text"
                          placeholder="4"
                        />
                        <span className="text-neutrals-500 text-xs sm:text-sm mt-1">
                          2000/users
                        </span>
                      </div>
                    </div>
                  ) : (
                    <span className="text-xs sm:text-sm md:text-base text-gray-700 leading-relaxed">
                      Ideal for large businesses looking for enterprise-class
                      compliance while diversifying revenue streams.
                    </span>
                  )}
                </div>

                {/* Includes Section */}
                <h3
                  className={`font-semibold text-xs sm:text-sm md:text-base text-gray-600 ${
                    plan === "Enterprise" ? "mt-5 sm:mt-6 md:mt-9" : "mt-4 sm:mt-5 md:mt-5 mb-2"
                  }`}
                >
                  {plan === "Enterprise"
                    ? "Includes (Professional Plan +)"
                    : plan === "Professional"
                    ? "Includes (Starter Plan +)"
                    : "Includes"}
                </h3>

                {/* Features */}
                {["ATS", "Workforce"].map((section) => (
                  <div key={section} className="mt-3 sm:mt-4">
                    <span className="font-medium text-xs sm:text-sm md:text-base text-gray-700">
                      {section}
                    </span>

                    <div className="space-y-1.5 sm:space-y-2 text-xs sm:text-sm md:text-base text-gray-600 mt-2">
                      {COMMON_FEATURES.map((feature) => (
                        <div key={feature} className="flex items-start sm:items-center gap-2">
                          <Button
                            icon="check_circle"
                            variant="text"
                            className="text-primary !px-0 !py-0 flex-shrink-0 mt-0.5 sm:mt-0"
                          />
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* Button — Always at Bottom */}
              <div className="p-3 sm:p-4 md:p-4 bg-white border-t border-gray-100">
                <Button
                  className="w-full text-xs sm:text-sm md:text-base"
                  color={plan === selectedPlan ? "primary" : "black"}
                  variant={plan === selectedPlan ? "contained" : "outlined"}
                  title={getButtonLabel(plan)}
                  onClick={() => {
                    setSelectedPlan(plan);
                    onContinue(plan);
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RenewStep;